/* OUTLWD — Fireline motion layer.
   Additive only: injects decorative furniture and scroll behaviour.
   Never touches cart, variant or checkout logic (that stays in ax.js). */
(function () {
  "use strict";

  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;

  var MARK_SVG =
    '<svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">' +
    '<circle cx="50" cy="50" r="40.5" fill="none" stroke="currentColor" stroke-width="11"/>' +
    '<line x1="23.5" y1="23.5" x2="76.5" y2="76.5" stroke="currentColor" stroke-width="11"/></svg>';

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }

  /* ---- 1. scroll-progress hairline ---- */
  function progress() {
    var bar = el("div", "ax-progress");
    bar.setAttribute("aria-hidden", "true");
    document.body.appendChild(bar);
    var ticking = false;
    function frame() {
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      var top = window.pageYOffset || doc.scrollTop || 0;
      bar.style.setProperty("--ax-p", (max > 0 ? top / max : 0).toFixed(4));
      ticking = false;
    }
    addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(frame);
    }, { passive: true });
    frame();
  }

  /* ---- 2. the seal, stamped into the hero ---- */
  function seal(size, caseNo) {
    var s = el("div", "ax-seal" + (size === "sm" ? " ax-seal--sm" : ""));
    s.setAttribute("role", "img");
    s.setAttribute("aria-label", "Verified codebreaker seal");
    var id = "axoc" + Math.floor(performance.now() % 100000);
    s.innerHTML =
      '<svg class="ax-seal-orbit" viewBox="0 0 100 100" aria-hidden="true">' +
        '<defs><path id="' + id + '" d="M50,50 m-42,0 a42,42 0 1,1 84,0 a42,42 0 1,1 -84,0"/></defs>' +
        '<text textLength="262" lengthAdjust="spacing"><textPath href="#' + id + '">' +
        'VERIFIED CODEBREAKER · ' + caseNo + ' · OUTLWD ·</textPath></text></svg>' +
      '<span class="ax-seal-core" aria-hidden="true"></span>' +
      '<span class="ax-seal-rim" aria-hidden="true"></span>' +
      '<span class="ax-seal-mark">' + MARK_SVG + '</span>';
    return s;
  }

  function heroSeal() {
    var hero = document.querySelector(".ax-hero, .axh-hero");
    if (!hero || hero.querySelector(".ax-hero-seal")) return;
    var wrap = el("div", "ax-hero-seal");
    wrap.appendChild(seal("lg", "DROP 001"));
    wrap.appendChild(el("small", null, "Every piece ships tamper-sealed"));
    hero.appendChild(wrap);

    if (reduce || !matchMedia("(hover: hover)").matches) return;
    var sl = wrap.querySelector(".ax-seal");
    hero.addEventListener("pointermove", function (e) {
      var r = sl.getBoundingClientRect();
      var dx = (e.clientX - (r.left + r.width / 2)) / Math.max(1, window.innerWidth);
      sl.style.setProperty("--ax-holo-a", (210 + dx * 140).toFixed(1) + "deg");
    });
  }

  /* ---- 3. kinetic wordmark band, above the footer on the homepage ---- */
  function kinetic() {
    if (!document.body.classList.contains("template-index") &&
        !/^\/($|\?)/.test(location.pathname)) return;
    var footer = document.querySelector(".ax-footer");
    if (!footer || document.querySelector(".ax-kinetic")) return;

    function row(text, solid) {
      var unit = "<span" + (solid ? ' class="solid"' : "") + ">" + new Array(5).join(text) + "</span>";
      return unit + unit;
    }
    var band = el("section", "ax-kinetic");
    band.setAttribute("aria-hidden", "true");
    band.innerHTML =
      '<div class="ax-kinetic-track">' + row("OUTLWD · VERIFIED CODEBREAKER · ", true) + "</div>" +
      '<div class="ax-kinetic-track rev">' + row("TOO LOUD TO BE LEGAL · STAY OUTLWD · ", false) + "</div>" +
      '<div class="ax-kinetic-fade"></div>';

    var line = el("div", "ax-fireline");
    line.setAttribute("aria-hidden", "true");
    footer.parentNode.insertBefore(line, footer);
    footer.parentNode.insertBefore(band, footer);
  }

  /* ---- 4. scroll reveals ---- */
  function reveals() {
    // Two sources of truth, deliberately unioned:
    //  1. elements this layer decides to animate, and
    //  2. elements a SECTION already stamped with [data-ax-reveal] in its markup.
    // Missing (2) is not cosmetic — the global CSS hides [data-ax-reveal] at
    // opacity 0, so anything stamped but never observed stays invisible forever.
    var selected = document.querySelectorAll(
      ".ax-section-head, .ax-card, .ax-cat, .ax-feature, .ax-offer, .ax-info-card, " +
      ".ax-premium-card, .ax-value-grid div, .ax-gallery, .ax-pdp-price, .ax-auth, " +
      ".axh-head, .axh-offer, .axh-split-card, .axh-image-card, .axh-visual-tile"
    );
    var preStamped = document.querySelectorAll("[data-ax-reveal]");
    var seen = [];
    Array.prototype.forEach.call(preStamped, function (t) { seen.push(t); });
    Array.prototype.forEach.call(selected, function (t) {
      if (seen.indexOf(t) === -1) seen.push(t);
    });
    var targets = seen;
    if (!targets.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      targets.forEach(function (t) { t.classList.add("ax-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("ax-in"); io.unobserve(e.target); }
      });
      // Reveal BEFORE the element reaches the viewport. Triggering on entry
      // leaves a visible blank during fast scrolling on a live store.
    }, { rootMargin: "700px 0px 700px 0px", threshold: 0 });

    // Sections that run their own scoped reveal (e.g. fl-collection's
    // [data-flc-reveal] cells) opt out, so a card never animates twice.
    targets = targets.filter(function (t) {
      return !t.closest("[data-flc-reveal]");
    });

    targets.forEach(function (t, i) {
      t.setAttribute("data-ax-reveal", "");
      if (i % 4) t.classList.add("ax-d" + (i % 4));
      io.observe(t);
    });

    // Safety net: content visibility is never allowed to depend on an
    // animation. Anything still hidden after 4s is shown unconditionally.
    setTimeout(function () {
      targets.forEach(function (t) {
        if (t.classList.contains("ax-in")) return;
        var b = t.getBoundingClientRect();
        if (b.top < innerHeight * 3) t.classList.add("ax-in");
        // farther down: re-register instead of revealing. If WebKit dropped
        // the original registration the fresh observe delivers a record and
        // the reveal still animates when the user actually arrives.
        else if (io) { io.unobserve(t); io.observe(t); }
      });
    }, 4000);
  }

  /* ---- 5. PDP: holo dot on the price + the authenticity card ---- */
  function pdpTrust() {
    var price = document.querySelector(".ax-pdp-price .ax-price");
    if (price && !price.querySelector(".ax-holo-dot")) {
      var dot = el("span", "ax-holo-dot");
      dot.setAttribute("role", "img");
      dot.setAttribute("aria-label", "Certified piece");
      dot.setAttribute("title", "Verified piece — ships tamper-sealed");
      price.appendChild(dot);
    }
    var atc = document.querySelector(".ax-pdp-atc");
    var host = atc && atc.parentNode;
    if (!host || document.querySelector(".ax-auth")) return;
    var card = el("div", "ax-auth");
    card.appendChild(seal("sm", "DROP 001"));
    // No payment mechanics asserted here — checkout owns that copy.
    card.appendChild(el("div", null,
      "<b>Every piece is checked and sealed.</b>" +
      "<span>Yours arrives in a sealed pouch with its own serial number, so you know it left us untouched.</span>"));
    host.parentNode.insertBefore(card, host.nextSibling);
  }

  /* ---- 6. VOID tape on sold-out cards ---- */
  function voidTape() {
    Array.prototype.forEach.call(document.querySelectorAll(".ax-card"), function (card) {
      if (card.querySelector(".ax-void-tape")) return;
      var txt = (card.textContent || "").toLowerCase();
      if (txt.indexOf("sold out") === -1) return;
      card.classList.add("ax-void");
      var tape = el("div", "ax-void-tape", "SOLD OUT · SOLD OUT · SOLD OUT · SOLD OUT");
      tape.setAttribute("aria-hidden", "true");
      card.appendChild(tape);
    });
  }

  /* ---- 7. rupee symbol ----
     The shop's money_format emits "Rs.1,299.00". Same currency, worse
     typography. Shopify wraps every formatted price in <span class="money">,
     so normalising the symbol there is presentational only — it never
     touches an amount, and checkout is Shopify-hosted and unaffected. */
  function rupee(scope) {
    var nodes = (scope || document).querySelectorAll("span.money");
    Array.prototype.forEach.call(nodes, function (n) {
      if (n.getAttribute("data-ax-inr") === "1") return;
      var t = n.textContent;
      if (t.indexOf("Rs.") === -1 && t.indexOf("Rs ") === -1) return;
      // "Rs.1,299.00" -> "₹1,299". Whole-rupee amounts only; anything with
      // real paise (".50") keeps its decimals.
      n.textContent = t
        .replace(/Rs\.\s?/g, "₹")
        .replace(/Rs\s/g, "₹")
        .replace(/(₹[\d,]+)\.00\b/g, "$1");
      n.setAttribute("data-ax-inr", "1");
    });
  }

  function watchPrices() {
    rupee(document);
    if (!("MutationObserver" in window)) return;
    var pending = false;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; rupee(document); });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* ---- 8. add to cart without leaving the page ----
     The default form POST to /cart/add redirects to /cart, which throws the
     shopper out of the browse flow. Intercept, add over AJAX, confirm with the
     brand's own language, and leave them exactly where they were. Falls back
     to the normal POST whenever anything is missing or fails. */

  function cartCountNodes() { return document.querySelectorAll(".ax-cart-count"); }

  function setCartCount(n) {
    Array.prototype.forEach.call(cartCountNodes(), function (el) {
      el.textContent = n;
      el.classList.remove("ax-count-pop");
      void el.offsetWidth;               // restart the animation
      el.classList.add("ax-count-pop");
    });
  }

  function toast(title, line, href) {
    var old = document.querySelector(".ax-toast");
    if (old) old.parentNode.removeChild(old);

    var t = el("div", "ax-toast");
    t.setAttribute("role", "status");
    t.setAttribute("aria-live", "polite");
    t.innerHTML =
      '<div class="ax-toast-line" aria-hidden="true"></div>' +
      '<div class="ax-toast-body">' +
        '<div class="ax-toast-seal"></div>' +
        '<div class="ax-toast-copy">' +
          '<b>' + title + '</b>' +
          '<span>' + line + '</span>' +
        '</div>' +
        '<div class="ax-toast-actions">' +
          '<button type="button" class="ax-toast-dismiss">Keep shopping</button>' +
          '<a class="ax-toast-view" href="' + (href || "/cart") + '">View bag</a>' +
        '</div>' +
      '</div>';
    t.querySelector(".ax-toast-seal").appendChild(seal("sm", "SEIZED"));
    document.body.appendChild(t);
    requestAnimationFrame(function () { t.classList.add("ax-toast-in"); });

    var timer = setTimeout(close, 6000);
    function close() {
      clearTimeout(timer);
      t.classList.remove("ax-toast-in");
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 320);
    }
    t.querySelector(".ax-toast-dismiss").addEventListener("click", close);
    t.addEventListener("pointerenter", function () { clearTimeout(timer); });
    return t;
  }

  function stampButton(btn) {
    if (!btn || btn.dataset.axStamped === "1") return;
    var original = btn.innerHTML;
    btn.dataset.axStamped = "1";
    btn.classList.add("ax-stamped");
    btn.innerHTML = "Added \u2713";
    setTimeout(function () {
      btn.innerHTML = original;
      btn.classList.remove("ax-stamped");
      delete btn.dataset.axStamped;
    }, 1700);
  }

  function ajaxCart() {
    if (!window.fetch || !window.FormData) return;

    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || form.tagName !== "FORM") return;
      var action = (form.getAttribute("action") || "");
      if (action.indexOf("/cart/add") === -1) return;

      // only our own buy buttons — never hijack an app's form
      var btn = form.querySelector(".ax-atc, .ax-pdp-atc, .flp-seize, button[type=submit]");
      if (!btn || btn.disabled) return;

      e.preventDefault();
      var busy = btn.getAttribute("aria-busy") === "true";
      if (busy) return;
      btn.setAttribute("aria-busy", "true");

      var title = "";
      var card = form.closest(".ax-card, .flh-mw, article");
      if (card) {
        var tEl = card.querySelector(".ax-card-title, .flh-mw-title, .flp-rc-title");
        if (tEl) title = tEl.textContent.trim();
      }
      if (!title) {
        var h1 = document.querySelector(".flp-title, .ax-title-row h1, h1");
        if (h1) title = h1.textContent.trim();
      }

      fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(form),
        headers: { "Accept": "application/json" },
        credentials: "same-origin"
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          btn.removeAttribute("aria-busy");
          if (!res.ok) {
            toast("Couldn&rsquo;t add that", (res.body && res.body.description) || "That piece is sold out right now.");
            return;
          }
          stampButton(btn);
          toast("Added to bag", (title || "Your piece") + " &mdash; free shipping across India.");
          return fetch("/cart.js", { credentials: "same-origin" })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              setCartCount(cart.item_count);
              document.dispatchEvent(new CustomEvent("ax:cart:updated", { detail: cart }));
              // On the cart PAGE the line items and totals are server-rendered;
              // an AJAX add must re-render or the new piece is invisible and
              // the discount maths stay stale.
              if (location.pathname.replace(/\/$/, "") === "/cart") location.reload();
            });
        })
        .catch(function () {
          btn.removeAttribute("aria-busy");
          form.submit();                 // last resort: the normal redirect
        });
    }, true);
  }

  /* ---- 9. the open-case pulse ----
     One cold dot in front of the case label so the drop reads as live. */
  /* ---- the self-link guard ----
     Tapping a link to the page you are already on — the cart icon while ON
     the cart, the logo while home — stacked a duplicate history entry, so
     leaving needed two presses of back. Same destination: no navigation,
     just a scroll to the top. Hash links and new-tab links pass through. */
  function selfLinkGuard() {
    document.addEventListener("click", function (e) {
      var a = e.target && e.target.closest ? e.target.closest("a[href]") : null;
      if (!a || a.target === "_blank") return;
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin || url.hash) return;
      if (url.pathname === location.pathname && url.search === location.search) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, true);
  }

  function livePulse() {
    var labels = document.querySelectorAll(".ax-case-label, .flh-case .ax-case-label, .count-label");
    Array.prototype.forEach.call(labels, function (el) {
      if (el.querySelector(".ax-livedot")) return;
      var d = el.ownerDocument.createElement("span");
      d.className = "ax-livedot";
      d.setAttribute("aria-hidden", "true");
      el.insertBefore(d, el.firstChild);
    });
  }

  /* ---- 10. the open dossier ----
     A fixed case-identity panel beside the scrolling store, desktop only.
     Its metadata swaps as you scroll past each section, so the panel reads
     as a case file being worked through rather than static chrome. */
  function dossier() {
    var page = document.querySelector(".ax-page");
    if (!page || document.querySelector(".ax-dossier")) return;

    var a = el("aside", "ax-dossier");
    a.setAttribute("aria-label", "Codebreaker file");
    a.innerHTML =
      '<div class="ax-dsr-top"><span class="ax-dsr-lockup"></span>' +
        '<span class="ax-dsr-sub">Verified<br>codebreaker</span></div>' +
      '<div class="ax-dsr-seal"></div>' +
      '<div class="ax-dsr-meta">' +
        '<div class="ax-dsr-row"><span class="k">Drop</span><span class="v" data-d="drop">Live now · 300 made</span></div>' +
        '<div class="ax-dsr-row"><span class="k">Viewing</span><span class="v" data-d="sec">Home</span></div>' +
        '<div class="ax-dsr-row"><span class="k">Style code</span><span class="v" data-d="serial">OUTLWD-001</span></div>' +
        '<div class="ax-dsr-row"><span class="k">Shipping</span><span class="v" data-d="ship">Free · all India</span></div>' +
      '</div>' +
      '<div class="ax-dsr-foot">Break the code.<br>Too loud to be legal.<br>Stay OUTLWD.</div>' +
      '<div class="ax-dsr-clock"><span class="k">This drop ends in</span><span class="t" data-d="clock">—</span></div>';
    a.querySelector(".ax-dsr-seal").appendChild(seal("lg", "DROP 001"));
    // The rail wears the same barcode lockup as the header — cloned from the
    // header's own <img> so the JS never hard-codes a theme asset URL. If the
    // header ever ships without it, fall back to the mark + wordmark.
    (function () {
      var slot = a.querySelector(".ax-dsr-lockup");
      var hImg = document.querySelector(".ax-header .ax-logo img");
      if (slot && hImg && (hImg.currentSrc || hImg.src)) {
        var im = document.createElement("img");
        im.src = hImg.currentSrc || hImg.src;
        im.alt = "OUTLWD";
        im.loading = "eager";
        slot.appendChild(im);
      } else if (slot) {
        slot.outerHTML = MARK_SVG + '<b>OUTLWD</b>';
      }
    })();
    // sits directly after the header: on desktop it is fixed so position in the
    // DOM is irrelevant, but on a phone it must stick below the sticky header.
    // NB: insert after the header's SECTION wrapper, not after the header
    // itself. A sticky element only sticks inside its parent's box, and the
    // header's shopify-section is only ~100px tall — the strip would scroll
    // straight off. Its parent must be the full-height .ax-page.
    var head = document.querySelector(".ax-header");
    var anchorEl = head ? (head.closest(".shopify-section") || head) : null;
    if (anchorEl && anchorEl.parentNode) anchorEl.parentNode.insertBefore(a, anchorEl.nextSibling);
    else if (page && page.firstChild) page.insertBefore(a, page.firstChild);
    else page.parentNode.insertBefore(a, page);

    // the strip's sticky offset has to match the real header height
    function headH() {
      var h = document.querySelector(".ax-header");
      var v = h ? Math.round(h.getBoundingClientRect().height) : 72;
      document.documentElement.style.setProperty("--ax-headh", v + "px");
    }
    headH();
    addEventListener("resize", headH, { passive: true });

    function set(key, val) {
      var n = a.querySelector('[data-d="' + key + '"]');
      if (!n || n.textContent === val) return;
      n.classList.add("ax-swap");
      setTimeout(function () { n.textContent = val; n.classList.remove("ax-swap"); }, 200);
    }

    /* seal tilts with the pointer, like foil under a lamp */
    if (!reduce && matchMedia("(hover: hover)").matches) {
      var sl = a.querySelector(".ax-seal");
      addEventListener("pointermove", function (e) {
        sl.style.setProperty("--ax-holo-a", (210 + ((e.clientX / innerWidth) - .5) * 140).toFixed(1) + "deg");
      }, { passive: true });
    }

    /* the style code comes from the page when there is one */
    var code = document.querySelector(".flp-serial, .flh-mw-serial, .flk-serial");
    if (code) {
      var m = (code.textContent || "").match(/OUTLWD-[\d-]+/);
      if (m) set("serial", m[0]);
    }
    if (/\/products\//.test(location.pathname)) set("sec", "Product");
    else if (/\/collections\//.test(location.pathname)) set("sec", "Shop");
    else if (/\/cart/.test(location.pathname)) set("sec", "Your bag");

    /* which section am I looking at? */
    var marks = [];
    Array.prototype.forEach.call(
      document.querySelectorAll("h1, h2, .ax-section-head h2, .flh-head h2, .flc-title, .flp-title"),
      function (h) {
        var t = (h.textContent || "").trim();
        if (t && t.length < 46) marks.push({ el: h, label: t });
      });
    // Which heading is the reader actually on? Driven by scroll rather than
    // IntersectionObserver: IO is silently throttled in some embedded/preview
    // contexts, and this label must never quietly stop tracking.
    if (marks.length) {
      function pick() {
        var line = innerHeight * 0.34, best = null, bestD = Infinity;
        for (var i = 0; i < marks.length; i++) {
          var r = marks[i].el.getBoundingClientRect();
          if (r.bottom < 0 || r.top > innerHeight) continue;   // off screen
          var d2 = Math.abs(r.top - line);
          if (r.top <= line && d2 < bestD) { bestD = d2; best = marks[i]; }
        }
        if (!best) {                                            // nothing above the line yet
          for (var j = 0; j < marks.length; j++) {
            var r2 = marks[j].el.getBoundingClientRect();
            if (r2.top > 0 && r2.top < innerHeight) { best = marks[j]; break; }
          }
        }
        if (best) set("sec", best.label);
      }
      // Throttled by timestamp rather than requestAnimationFrame: rAF is
      // suspended in background tabs and some embedded viewers, and the label
      // would silently freeze at whatever it read on load.
      var lastRun = 0;
      addEventListener("scroll", function () {
        var now = Date.now();
        if (now - lastRun < 120) return;
        lastRun = now;
        pick();
      }, { passive: true });
      addEventListener("resize", pick, { passive: true });
      pick();
    }

    /* the countdown mirrors the drop deadline the homepage already carries */
    var host = document.querySelector("[data-flh-deadline]");
    var iso = host ? host.getAttribute("data-flh-deadline") : "2026-09-30T18:00:00+05:30";
    var end = Date.parse(iso);
    if (isNaN(end)) end = Date.parse("2026-09-30T18:00:00+05:30");
    function pad(n) { return (n < 10 ? "0" : "") + n; }
    function tick() {
      var ms = end - Date.now();
      var node = a.querySelector('[data-d="clock"]');
      if (!node) return;
      if (ms <= 0) { var clk = a.querySelector(".ax-dsr-clock"); if (clk) clk.style.display = "none"; return; }
      var s2 = Math.floor(ms / 1000);
      node.textContent = pad(Math.floor(s2 / 86400)) + ":" + pad(Math.floor(s2 / 3600) % 24) +
                         ":" + pad(Math.floor(s2 / 60) % 60) + ":" + pad(s2 % 60);
      setTimeout(tick, 1000);
    }
    tick();
  }

  /* ---- 11. the drop stated in numbers, as the prototype does ---- */
  function dropStats() {
    if (!/^\/($|\?)/.test(location.pathname) && !document.body.classList.contains("template-index")) return;
    if (document.querySelector(".ax-stats")) return;
    var hero = document.querySelector(".axh-hero, .ax-hero");
    if (!hero) return;

    var cards = document.querySelectorAll(".ax-card, .flh-mw");
    var total = cards.length, gone = 0;
    Array.prototype.forEach.call(cards, function (c) {
      if (/sold out/i.test(c.textContent || "")) gone++;
    });
    if (!total) return;

    var wrap = el("section", "ax-stats");
    wrap.setAttribute("aria-label", "This drop in numbers");
    function stat(n, label) {
      return '<div class="ax-stat"><b>' + n + '</b><span>' + label + '</span></div>';
    }
    wrap.innerHTML =
      stat(("0" + Math.min(99, total)).slice(-2), "Styles in this drop") +
      stat(("0" + Math.min(99, gone)).slice(-2), "Already sold out") +
      stat("00", "Restocks planned");

    // sits directly beneath the hero, above whatever follows it
    var after = hero.closest(".shopify-section") || hero;
    if (after.parentNode) after.parentNode.insertBefore(wrap, after.nextSibling);
  }

  /* ---- 12. the evidence list's second line ----
     The prototype gives every row a line under the name. Most products have
     no variant title to show, so use the style code — same convention the
     PDP prints, derived from the variant id already in the add-to-cart form. */
  function listSubtitles() {
    var rows = document.querySelectorAll(".flc-grid .ax-card");
    Array.prototype.forEach.call(rows, function (card) {
      var body = card.querySelector(".ax-card-body");
      if (!body || body.querySelector(".ax-card-color")) return;
      var input = card.querySelector('input[name="id"]');
      if (!input || !input.value) return;
      var code = "Style OUTLWD-001-" + (parseInt(input.value, 10) % 9999);
      var line = el("div", "ax-card-color", code);
      var title = body.querySelector(".ax-card-title");
      if (title && title.nextSibling) body.insertBefore(line, title.nextSibling);
      else body.appendChild(line);
    });
  }

  /* ---- 13. the vault stack ----
     Turns each top-level section into a sticky panel that the next one
     covers. Panels taller than the viewport opt out (.ax-flow) so nothing
     can ever trap the reader or hide a buy button below a fold. */
  function vaultStack() {
    if (reduce) return;
    // 2026-10-23: the product page left the vault — the pinned panels covered the
    // add-to-cart (a tap on its position landed on the Description heading) and
    // pushed the price below the fold. The PDP flows normally now.
    // 2026-10-23 b: the homepage left the vault too — pinned product bands cropped
    // their own add-to-cart rows (viewport-height panels) and lingered behind later
    // sections while scrolling. Commerce scrolls; the stack stays on collection + cart.
    var root = document.querySelector(".flc, .flk");
    if (!root) return;

    // Only real sections become panels. Measured BEFORE any stacking styles
    // are applied — otherwise a 60px breadcrumb bar becomes a full-screen
    // panel and shoves the product a whole viewport down the page.
    // clientHeight, not innerHeight: it is the CSS layout viewport — the same
    // thing 100svh measures — and it stays honest inside embedded viewers that
    // report a made-up innerHeight.
    function vpH() { return document.documentElement.clientHeight || innerHeight; }
    var minPanel = Math.max(300, vpH() * 0.38);
    // The stack has an invariant that is easy to miss: EVERY section between two
    // pinned panels has to be able to cover one, because a pinned panel stays put
    // until something taller than the screen slides over it. A 165px countdown
    // between two 825px panels covers a sixth of the screen and leaves the pinned
    // panel behind it on show for the rest — the "content from a section above"
    // leak on the homepage.
    //
    // This only holds where the page is BUILT as a stack of full sections, which
    // is the homepage. On a product, collection or cart page the children are a
    // breadcrumb bar, a filter row, a price block — furniture that must never
    // become a full-screen panel. Applying the homepage rule there turned every
    // strip into a screen and buried those pages in overlays. So: homepage takes
    // the invariant, everything else keeps the height bar it always had.
    // The homepage is BUILT as a stack of full sections, so every one of its
    // children is a panel — including the short countdown, ticker and trust
    // strip. That is what keeps the chain unbroken: a pinned panel needs the
    // next section to be full height or it stays on show behind it, and it is
    // also what keeps every section animating rather than only half of them.
    //
    // A product, collection or cart page is not built that way. Its children are
    // a breadcrumb bar, a filter row, a price block — furniture that must never
    // become a full-screen panel. Those keep the height bar they always had.
    var isHome = root.classList.contains("flh");
    var kids = Array.prototype.filter.call(root.children, function (n) {
      if (n.nodeType !== 1) return false;
      if (n.classList.contains("ax-fireline")) return false;   // hairlines are seams, not panels
      if (n.classList.contains("ax-stats")) return false;
      if (n.classList.contains("ax-dossier")) return false;
      if (n.classList.contains("ax-vaultskip")) return false;  // section opted out (e.g. the premium catalog band: taller than the usable viewport, its buy rows were covered)
      return n.getBoundingClientRect().height >= (isHome ? 40 : minPanel);
    });
    if (kids.length < 2) return;

    kids.forEach(function (n, i) {
      n.classList.add("ax-stack");
      n.style.setProperty("--ax-z", String(i + 1));
      // The panel must stay full-bleed and opaque while its CONTENTS shrink.
      // Scaling the panel itself pulled its edges off the viewport and showed
      // the section behind it through the gap — which is what the stack looked
      // like it was leaking. Same structure the prototype uses.
      var inner = n.querySelector(":scope > .ax-stack-in");
      if (!inner) {
        inner = document.createElement("div");
        inner.className = "ax-stack-in";
        // Only the in-flow content moves. An absolutely positioned child — the
        // hero photograph, a seal, a strip of tape — is anchored to the panel,
        // and a wrapper that scales becomes its containing block: the photo
        // would resize to the text block and slide under the scrim.
        var move = [];
        Array.prototype.forEach.call(n.childNodes, function (c) {
          if (c.nodeType === 1) {
            var pos = getComputedStyle(c).position;
            if (pos === "absolute" || pos === "fixed") return;
          }
          move.push(c);
        });
        move.forEach(function (c) { inner.appendChild(c); });
        n.appendChild(inner);
      }

      /* A full-screen panel that pins looks exactly like the end of the page.
         Every panel with something after it says so, and the cue is a real
         control — press it and the next one comes up. */
      if (!n.querySelector(":scope > .ax-more") && kids[i + 1]) {
        var cue = document.createElement("button");
        cue.type = "button";
        cue.className = "ax-more";
        cue.setAttribute("aria-label", "Go to the next section");
        cue.innerHTML = '<span class="ax-more-txt">More below</span>' +
                        '<span class="ax-more-arrow" aria-hidden="true"></span>';
        cue.addEventListener("click", function () {
          var next = kids[i + 1];
          if (next) next.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
        });
        n.appendChild(cue);
      }
    });

    function headOffset() {
      var h = document.querySelector(".ax-header");
      var strip = document.querySelector(".ax-dossier");
      var v = h ? h.getBoundingClientRect().height : 0;
      if (strip && getComputedStyle(strip).position === "sticky") v += strip.getBoundingClientRect().height;
      return Math.round(v);
    }

    // layout() toggles .ax-flow on every panel in order to measure them, which
    // resizes their contents and so trips the ResizeObserver installed below.
    // Without this latch the two drive each other in a loop.
    var laying = false;
    function layout() {
      if (laying) return;
      laying = true;
      // --ax-headh belongs to the header alone; the dossier strip pins to it.
      // The panels sit below BOTH, so they get their own variable. Writing the
      // combined figure into --ax-headh pushed the strip a strip-height down
      // the screen and left it floating in mid-air.
      var off = headOffset();
      document.documentElement.style.setProperty("--ax-stacktop", off + "px");
      var vh = vpH() - off;
      // Measure with stacking OFF first. .ax-stack forces a full-viewport
      // min-height, so measuring while it applies makes every panel look too
      // tall and the whole stack silently opts out.
      // Three strips that used to be children of the home root — the CASE 001
      // countdown, the wordmark band and the proof strip — now ride inside a
      // neighbouring panel's head as .flh-inlay, with the host carrying
      // .flh-has-inlay (which zeroes its top padding so the strip sits flush).
      // Measure with BOTH lifted. Every panel then reports exactly the height it
      // reported before the fold, so folding a strip in cannot move a pin
      // decision — these panels were hand-tuned against these numbers and this
      // is the guarantee, rather than an argument about which side of
      // `natural <= vh - 2` a 190px band leaves a 698px section on.
      // Restored a few lines below, inside this same synchronous pass, so the
      // page is never painted in this state.
      var folded = root.querySelectorAll(".flh-inlay");
      var inlayHosts = root.querySelectorAll(".flh-has-inlay");
      Array.prototype.forEach.call(folded, function (s) { s.style.display = "none"; });
      Array.prototype.forEach.call(inlayHosts, function (h) { h.classList.remove("flh-has-inlay"); });
      kids.forEach(function (n) { n.classList.add("ax-flow"); });
      void root.offsetHeight;
      // The laid-out box, not scrollHeight. scrollHeight counts absolutely
      // positioned decoration hanging past the panel — the hero's glow put it
      // 192px "over budget" and kept a panel that fits out of the stack.
      var natural = kids.map(function (n) { return Math.round(n.getBoundingClientRect().height); });
      // How much of that height is actually CONTENT. Measuring the padded box let
      // padding earn a panel its pin: "Find Your Style" measured 429 of a 560
      // screen (77%) and passed, but only 295px of that was anything you could
      // see — the rest was padding, and it pinned as a mostly empty band. The
      // fits-the-screen test still uses the padded box; the fills-the-screen test
      // now uses the ink.
      var filled = kids.map(function (n) {
        var inner = n.querySelector(":scope > .ax-stack-in") || n;
        var top = Infinity, bot = -Infinity;
        Array.prototype.forEach.call(inner.children, function (c) {
          var r = c.getBoundingClientRect();
          if (r.height < 6 || r.width < 6) return;
          if (r.top < top) top = r.top;
          if (r.bottom > bot) bot = r.bottom;
        });
        return bot > top ? Math.round(bot - top) : 0;
      });
      // measurement done — put the folded-in strips and their hosts' padding
      // back before anything below reads the DOM or the page is painted
      Array.prototype.forEach.call(inlayHosts, function (h) { h.classList.add("flh-has-inlay"); });
      Array.prototype.forEach.call(folded, function (s) { s.style.display = ""; });
      kids.forEach(function (n, i) {
        // The last panel is never covered by anything, so a full-viewport
        // height buys it nothing — it just leaves dead space under the content.
        if (i === kids.length - 1) return;
        // A panel has to be able to carry a screen to earn one; anything thinner
        // flows like an ordinary section rather than pinning as a dead band.
        // A pinned panel stays put until something taller than the screen slides
        // over it. If the next thing in the DOM is a 165px countdown or a 209px
        // proof band, it covers a fifth of the screen and leaves this panel on
        // show behind it — the "content from the section above" leak. So a panel
        // only earns a pin when the next section along is itself a panel, and
        // therefore full height. Hairline seams do not count as a break.
        // Both extra tests are homepage-only. Everywhere else this is the rule the
        // page shipped with — fits the screen, so it pins — because the product,
        // collection and cart layouts were built and tuned against that and the
        // stricter tests changed which of their sections stack.
        if (!isHome) {
          // The PDP stage/buy panels measure within a few px of (viewport -
          // header), so the exact-fit rule flipped per device: a 390pt iPhone
          // pinned them, a 420pt one flowed them and the whole vault chain
          // (and with it the sticky-ATC handoff) died. Those two panels end
          // in a designed fade, so pinning them with up to ~120px of tail
          // clipped is safe. Everything else keeps the exact-fit rule -
          // clipping a collection deck or cart panel cuts real content.
          var tol = n.classList.contains("flp-buy") ? 120 : 0;
          if (natural[i] <= vh - 2 + tol) n.classList.remove("ax-flow");
          return;
        }
        var nxt = n.nextElementSibling;
        while (nxt && nxt.classList.contains("ax-fireline")) nxt = nxt.nextElementSibling;
        var coverable = !!nxt && kids.indexOf(nxt) !== -1;
        if (coverable && natural[i] <= vh - 2 && filled[i] >= vh * 0.55) n.classList.remove("ax-flow");
      });
      frame();
      // release a frame later, once those class changes have settled. The rAF
      // alone deadlocked: in a tab that loads hidden (background tab, restored
      // session) rAF is frozen, the latch stayed true, and every image-load
      // re-measure no-opped — panels measured before their images landed then
      // stayed out of the stack for the life of the page. The timeout fires
      // even in hidden tabs.
      var releaseLatch = function () { laying = false; };
      requestAnimationFrame(releaseLatch);
      setTimeout(releaseLatch, 250);
    }

    var last = 0;
    function frame() {
      var off = headOffset(), h = innerHeight - off;
      for (var i = 0; i < kids.length; i++) {
        var n = kids[i], next = kids[i + 1];
        if (!next || n.classList.contains("ax-flow")) { n.style.setProperty("--ax-cover", "0"); continue; }
        var r = next.getBoundingClientRect();
        var c = 1 - Math.min(1, Math.max(0, (r.top - off) / h));
        n.style.setProperty("--ax-cover", c.toFixed(3));
      }
    }
    addEventListener("scroll", function () {
      var now = Date.now();
      if (now - last < 16) return;
      last = now;
      frame();
    }, { passive: true });
    addEventListener("resize", layout, { passive: true });
    // Panels measured before the webfont and the images settle come out taller
    // than they end up, and a panel measured too tall opts out of the stack for
    // good. Measure again once the page has actually stopped moving.
    addEventListener("load", layout);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout).catch(function () {});
    // A page laid out while its tab was hidden measured cold (frozen rAF,
    // lazy images unfired) — measure once more when it actually becomes
    // visible, which is the first moment the result can be seen anyway.
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) setTimeout(layout, 60);
    });

    // load, resize and fonts.ready all fire before the product photography does.
    // A panel measured while its images are still empty boxes gets pinned at a
    // height its content then outgrows, and overflow:hidden slices whatever
    // arrived late — which is why cards showed cut off mid-word on a phone but
    // never on a desktop where everything was cached. Watch the content itself
    // and re-measure whenever it actually changes size.
    if (window.ResizeObserver) {
      var pending = null;
      var ro = new ResizeObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(layout, 120);        // coalesce a burst of images
      });
      kids.forEach(function (n) {
        var inner = n.querySelector(":scope > .ax-stack-in");
        if (inner) ro.observe(inner);
      });
    } else {
      // no ResizeObserver: settle for re-measuring as each image lands
      Array.prototype.forEach.call(root.querySelectorAll("img"), function (img) {
        if (!img.complete) img.addEventListener("load", layout, { once: true });
      });
    }
    layout();
  }

  /* ---- 14. let the header actually stick ---- */
  function stickHeader() {
    var h = document.querySelector(".ax-header");
    if (!h) return;
    var sec = h.closest(".shopify-section");
    // The menu drawer ships inside the header's section. Making that section
    // sticky gives it a stacking context, and a stacking context caps every
    // z-index inside it — the drawer asks for 100 and gets the section's. It
    // only cleared the sidebar because 70 > 60, which is luck, not design.
    // Lift the drawer to the page so its z-index means what it says.
    var drawer = document.querySelector(".ax-drawer");
    var page = document.querySelector(".ax-page") || document.body;
    if (drawer && drawer.parentElement !== page) page.appendChild(drawer);
    // Sticky only travels inside the parent's box. The header's own box is
    // exactly header-height, so it never moved — the SECTION has to be the
    // sticky one, since its parent is the full-height .ax-page.
    if (sec) sec.classList.add("ax-headsec");
    function headH() {
      document.documentElement.style.setProperty(
        "--ax-headh", Math.round(h.getBoundingClientRect().height) + "px");
    }
    headH();
    addEventListener("resize", headH, { passive: true });
  }

  /* ---- 14. deal the Most Wanted pieces out as a hand of cards ---- */
  function cardFan() {
    var rail = document.querySelector(".flh-rail");
    if (!rail || rail.classList.contains("ax-fan")) return;
    if (rail.children.length < 3) return;

    rail.classList.add("ax-fan");

    // The hand holds four. A class on each card — not "> *" — so section rules
    // like .flh-mw{position:relative} can't outrank the fan's positioning.
    var kids = Array.prototype.slice.call(rail.children);
    kids.slice(0, 4).forEach(function (c) { c.classList.add("ax-fan__card"); });
    if (kids.length > 4) {
      var rest = document.createElement("div");
      rest.className = "ax-fan-rest";
      kids.slice(4).forEach(function (c) { rest.appendChild(c); });
      rail.parentNode.insertBefore(rest, rail.nextSibling);
    }

    // A tap anywhere on a card opens that piece. The cards overlap by design,
    // so "tap to lift" left shoppers poking at a card that only moved — on a
    // touchscreen the obvious thing to do with a product card is open it.
    rail.addEventListener("click", function (ev) {
      var card = ev.target.closest(".ax-fan__card");
      if (!card || !rail.contains(card)) return;
      if (ev.target.closest("a, button")) return;   // real controls win
      var link = card.querySelector('a[href*="/products/"]') || card.querySelector("a[href]");
      if (link) location.href = link.href;
    });

    // The cards are absolutely positioned, so they contribute nothing to the
    // fan's height. Left to a fixed height the hand spills onto whatever comes
    // next — measure the real cards and give the fan room for the tallest.
    function sizeFan() {
      var tall = 0;
      kids.slice(0, 4).forEach(function (c) { tall = Math.max(tall, c.offsetHeight); });
      // just enough room for the lift, no more — the band has a screen to fit in
      if (tall) rail.style.height = (tall + 28) + "px";
    }
    sizeFan();
    addEventListener("resize", sizeFan, { passive: true });
    addEventListener("load", sizeFan);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sizeFan).catch(function () {});

    // Drag a finger across the hand and the card under it rises — the pile
    // reacts continuously instead of waiting for a tap to land. Pointer events
    // cover mouse and touch alike; a real tap still opens the piece.
    var lifted = null;
    function liftAt(x, y) {
      var el = document.elementFromPoint(x, y);
      var card = el && el.closest ? el.closest(".ax-fan__card") : null;
      if (card && !rail.contains(card)) card = null;
      if (card === lifted) return;
      if (lifted) lifted.classList.remove("ax-up");
      lifted = card;
      if (card) card.classList.add("ax-up");
    }
    rail.addEventListener("pointermove", function (ev) {
      if (ev.pointerType === "mouse") return;   // hover already covers a mouse
      liftAt(ev.clientX, ev.clientY);
    }, { passive: true });
    rail.addEventListener("pointerdown", function (ev) {
      if (ev.pointerType === "mouse") return;
      liftAt(ev.clientX, ev.clientY);
    }, { passive: true });
    function dropCard() {
      if (lifted) { lifted.classList.remove("ax-up"); lifted = null; }
    }
    rail.addEventListener("pointerup", dropCard);
    rail.addEventListener("pointercancel", dropCard);
    rail.addEventListener("pointerleave", dropCard);

    // say what the hand does, but only where there is a hand to speak of
    var note = document.querySelector(".flh-rail-note");
    if (note) note.textContent = "Run a finger across the hand \u2014 tap a card to open it.";

    function deal() {
      var r = rail.getBoundingClientRect();
      if (r.top < (document.documentElement.clientHeight || innerHeight) * 0.92 && r.bottom > 0) {
        rail.classList.add("ax-dealt");
        removeEventListener("scroll", onScroll);
      }
    }
    function onScroll() { deal(); }
    addEventListener("scroll", onScroll, { passive: true });
    deal();
    // never leave the hand face-down if the scroll signal never arrives
    setTimeout(function () { rail.classList.add("ax-dealt"); }, 2500);
  }

  /* ---- 16. the drawer: flick through the first pieces of a category ---- */
  function collectionDeck() {
    var deck = document.querySelector("[data-flc-deck]");
    if (!deck) return;
    var band = deck.closest("[data-flc-drawer]");
    if (!band) return;
    var cards = Array.prototype.slice.call(deck.children);
    if (cards.length < 2) return;

    var count = band.querySelector("[data-flc-count]");
    var bar = band.querySelector(".flc-deckbar");
    var cur = 0;

    function pad(n) { return (n < 10 ? "0" : "") + n; }
    function nameOf(c) {
      var t = c.querySelector(".ax-card-title");
      return t ? t.textContent.trim() : "";
    }

    // A card behind the front one must not be reachable by keyboard. Only undo
    // the tabindex we added ourselves, so anything the markup set stays put.
    function reach(card, on) {
      Array.prototype.forEach.call(card.querySelectorAll("a, button, input, select, textarea"), function (f) {
        if (!on) {
          if (!f.hasAttribute("tabindex")) { f.setAttribute("tabindex", "-1"); f.setAttribute("data-ax-tab", "1"); }
        } else if (f.getAttribute("data-ax-tab") === "1") {
          f.removeAttribute("tabindex"); f.removeAttribute("data-ax-tab");
        }
      });
    }

    function render() {
      cards.forEach(function (c, i) {
        var rel = i - cur;
        if (rel < 0) {
          c.style.transform = "translateX(-128%) rotate(-8deg)"; c.style.opacity = "0";
        } else if (rel > 3) {
          c.style.transform = "translateY(-40px) scale(.86)"; c.style.opacity = "0";
        } else {
          c.style.transform = "translateY(" + (rel * -13) + "px) scale(" + (1 - rel * .05).toFixed(3) + ")";
          c.style.opacity = rel === 0 ? "1" : (0.9 - rel * 0.22).toFixed(2);
        }
        c.style.zIndex = String(50 - rel);
        var front = rel === 0;
        c.setAttribute("aria-hidden", front ? "false" : "true");
        c.style.pointerEvents = front ? "auto" : "none";
        reach(c, front);
      });
      if (count) count.textContent = pad(cur + 1) + " / " + pad(cards.length) + " \u00b7 " + nameOf(cards[cur]);
    }
    function go(n) { cur = (n + cards.length) % cards.length; render(); }
    render();

    var prev = band.querySelector("[data-flc-prev]"), next = band.querySelector("[data-flc-next]");
    if (prev) prev.addEventListener("click", function () { go(cur - 1); });
    if (next) next.addEventListener("click", function () { go(cur + 1); });

    deck.addEventListener("keydown", function (ev) {
      if (ev.key === "ArrowRight") { ev.preventDefault(); go(cur + 1); }
      else if (ev.key === "ArrowLeft") { ev.preventDefault(); go(cur - 1); }
    });

    var sx = null;
    deck.addEventListener("pointerdown", function (ev) { sx = ev.clientX; });
    deck.addEventListener("pointerup", function (ev) {
      if (sx === null) return;
      var dx = ev.clientX - sx; sx = null;
      if (Math.abs(dx) > 58) go(dx < 0 ? cur + 1 : cur - 1);
    });
    deck.addEventListener("pointercancel", function () { sx = null; });

    // Cards / Grid — Grid drops the deck and takes you to the full listing
    var modes = Array.prototype.slice.call(band.querySelectorAll("[data-flc-mode]"));
    modes.forEach(function (b) {
      b.addEventListener("click", function () {
        var mode = b.getAttribute("data-flc-mode"), showDeck = mode === "deck";
        modes.forEach(function (o) {
          o.setAttribute("aria-pressed", o.getAttribute("data-flc-mode") === mode ? "true" : "false");
        });
        deck.hidden = !showDeck;
        if (bar) bar.hidden = !showDeck;
        band.classList.toggle("flc-flat", !showDeck);
        // the band just changed height — let the vault re-measure its panels
        dispatchEvent(new Event("resize"));
        if (!showDeck) {
          var core = document.querySelector(".flc-core");
          if (core) core.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });
  }

  /* ---- 16b. the drawer opens on Grid ----
     Same state change as pressing Grid (minus the scroll to the listing), run
     AFTER vaultStack so the stack measures the drawer at full height exactly as
     it always has. The deck stays one tap away behind Cards. */
  function collectionDefaultGrid() {
    var deck = document.querySelector("[data-flc-deck]");
    if (!deck) return;
    var band = deck.closest("[data-flc-drawer]");
    if (!band) return;
    var modes = Array.prototype.slice.call(band.querySelectorAll("[data-flc-mode]"));
    modes.forEach(function (o) {
      o.setAttribute("aria-pressed", o.getAttribute("data-flc-mode") === "grid" ? "true" : "false");
    });
    deck.hidden = true;
    var bar = band.querySelector(".flc-deckbar");
    if (bar) bar.hidden = true;
    band.classList.add("flc-flat");
    band.removeAttribute("data-flc-view");
    dispatchEvent(new Event("resize"));
  }

  /* ---- 17. the category list loads itself: no pages, no repeats ---- */
  function endlessCollection() {
    var grid = document.querySelector(".flc-grid");
    var pager = document.querySelector("[data-flc-pager]");
    var nextCats = document.querySelector("[data-flc-next-cats]");
    if (!grid) return;

    function finish() {
      if (pager) pager.remove();
      if (nextCats) nextCats.hidden = false;
    }
    if (!pager) { finish(); return; }

    var link = pager.querySelector('a[rel="next"]');
    if (!link) { finish(); return; }

    var nextUrl = link.href, busy = false, seen = {};
    // remember what is already on the page, so a repeated URL can never
    // append the same piece twice
    Array.prototype.forEach.call(grid.querySelectorAll('a[href*="/products/"]'), function (a) {
      seen[a.pathname] = 1;
    });

    pager.innerHTML = '<p class="flc-loading" data-flc-loading>Loading more\u2026</p>';
    // .flc-count is also the deck's counter — take the one in the listing
    var note = document.querySelector(".flc-core .flc-count");
    if (note) note.textContent = note.textContent.replace(/Showing\s*\d+\D+?\d+\s*of\s*/, "Showing all ").trim();

    function pull() {
      if (busy || !nextUrl) return;
      busy = true;
      fetch(nextUrl, { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var cells = doc.querySelectorAll(".flc-grid .flc-cell");
          var added = 0;
          Array.prototype.forEach.call(cells, function (cell) {
            var a = cell.querySelector('a[href*="/products/"]');
            if (a && seen[a.pathname]) return;      // never the same piece twice
            if (a) seen[a.pathname] = 1;
            cell.removeAttribute("style");
            cell.setAttribute("data-ax-reveal", "");
            cell.classList.add("ax-in");
            grid.appendChild(cell);
            added++;
          });
          var more = doc.querySelector('[data-flc-pager] a[rel="next"]');
          nextUrl = more ? more.href : null;
          busy = false;
          if (!nextUrl || added === 0) { finish(); return; }
          watch();
        })
        .catch(function () { busy = false; nextUrl = null; finish(); });
    }

    function watch() {
      var loading = document.querySelector("[data-flc-loading]");
      if (!loading) return;
      var r = loading.getBoundingClientRect();
      var vh = document.documentElement.clientHeight || innerHeight;
      if (r.top < vh * 1.6) pull();
    }
    addEventListener("scroll", watch, { passive: true });
    addEventListener("resize", watch, { passive: true });
    watch();
  }

  function boot() {
    try { progress(); } catch (e) {}
    try { heroSeal(); } catch (e) {}
    try { kinetic(); } catch (e) {}
    try { pdpTrust(); } catch (e) {}
    try { voidTape(); } catch (e) {}
    try { watchPrices(); } catch (e) {}
    try { livePulse(); } catch (e) {}
    try { dossier(); } catch (e) {}
    try { dropStats(); } catch (e) {}
    try { listSubtitles(); } catch (e) {}
    try { stickHeader(); } catch (e) {}
    try { cardFan(); } catch (e) {}
    try { collectionDeck(); } catch (e) {}
    try { endlessCollection(); } catch (e) {}
    try { selfLinkGuard(); } catch (e) {}
    try { vaultStack(); } catch (e) {}
    try { collectionDefaultGrid(); } catch (e) {}
    // AFTER vaultStack, deliberately: vaultStack re-parents every panel child
    // into a freshly built .ax-stack-in, and an IntersectionObserver target
    // that is detached and re-attached stops reporting in WebKit. Observing
    // only once the DOM has its final shape closes that hole — this was the
    // "panel renders as just its shadow" bug on iOS product pages.
    try { reveals(); } catch (e) {}
    try { ajaxCart(); } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();
